import { Component, h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import PostEditor from '../editor/postEditorViaAPI'
import { ContentType } from '@insided/shared/utils/contentType'
import classNames from 'classnames'

interface Props {
  topicId: number
  isGuest: boolean
  type: ContentType
}

class TopicAddReply extends Component<Props, {}> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }

  render () {
    const { topicId, isGuest, type } = this.props
    return (
      <div className={classNames('box__content', 'qa-reply', 'reply-editor-wrapper')}>
        <h3>
          <Phrase p='editor.title.comment' />
        </h3>
        <br />
        <PostEditor
          type={type}
          disableFileAttachments={false}
          topicId={topicId}
          replyId={null}
          isControl={false}
          onSuccess={() => window.location.reload()}
          redirect={false}
          isGuest={isGuest}
        />
      </div>
    )
  }
}

export default TopicAddReply
